<template>
  <!-- navigate bar bottom-->
  <el-row>
        <el-row type="flex" align="middle" style="height: 40px;">
            <tags-view></tags-view>
        </el-row>
    </el-row>
</template>

<script>
    import TagsView from "./TagsView";
    export default {
        name: "navigateBarBottom",
        components: {
            TagsView
        }

    }
</script>



// WEBPACK FOOTER //
// src/components/layout/NavibarBottom.vue